// extracted by mini-css-extract-plugin
export default {"list":"webpack-components-core-List-List-module__list","listItem":"webpack-components-core-List-List-module__listItem"};